import styled from 'styled-components';

export const CollapseItemLabelContainer = styled.div`
  font-weight: ${({ theme }) => theme.deprecated_.fontWeights.bold};

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;
